<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);

const strokeClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 22 20">
    <path
      d="M2.57617 1H19.4238C20.2943 1 21 1.67657 21 2.51114V14.9365C21 15.7711 20.2943 16.4477 19.4238 16.4477H11.281V18.4571H16.1828C16.3391 18.4571 16.4659 18.5787 16.4659 18.7286C16.4659 18.8785 16.3391 19 16.1828 19H5.81724C5.66089 19 5.53412 18.8785 5.53412 18.7286C5.53412 18.5787 5.66089 18.4571 5.81724 18.4571H10.719V16.4477H2.57617C1.70568 16.4477 1 15.7711 1 14.9365V2.51114C1 1.67657 1.70568 1 2.57617 1ZM20.438 2.51114C20.438 1.97637 19.9816 1.53883 19.4238 1.53883H2.57617C2.01838 1.53883 1.56201 1.97637 1.56201 2.51114V13.6442H20.438V2.51114ZM1.56201 14.9365C1.56201 15.4713 2.01838 15.9088 2.57617 15.9088H19.4238C19.9816 15.9088 20.438 15.4713 20.438 14.9365V14.183H1.56201V14.9365Z"
      :class="colorClass + ' ' + strokeClass"
      stroke-width="0.4"
    />
    <path
      d="M14.1216 6.53971L13.7002 6.95444L11.5614 4.71816V11.1342H10.9715V4.71816L8.82864 6.95444L8.4073 6.53971L11.2644 3.5553L14.1216 6.53971Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
